import Papa from 'papaparse'

export default function downloadCsv(filename: string, data: any[][]) {
  const text = Papa.unparse(data)
  const element = document.createElement('a')
  element.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(text))
  element.setAttribute('download', filename)
  element.style.display = 'none'
  document.body.appendChild(element)
  element.click()
  document.body.removeChild(element)
}
